import { Component, OnInit } from '@angular/core';
import { MasterService,ClassroomService,FrontOffService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppGlobals } from '../../shared/app.global';

@Component({
  selector: 'app-reportcard',
  templateUrl: './reportcard.component.html',
  styleUrls: ['./reportcard.component.scss'],
  
  providers:[MasterService,ClassroomService,FrontOffService]
})
export class ReportcardComponent implements OnInit {

  sections:any=[];
  classes:any=[];
  arrmsumgd:any=[];
  objformat:any={};
  attcordata:any=[];
  arrsubjects:any=[];
  arrstudent:any=[];
  fmodel:any={clid:'0',secid:'0',subid:'0',prid:'0',atscope:'Individual'};
  attdata:any=[];
  attdatawp:any=[];
  arrper:any=[];
  attcordetdata:any=[];
  arrcnmcls:any=[];
  arrcourse:any=[];
  oprtype:any='';
  tabledata: any = {};
  objclass:any={};
  arrstulst:any=[];
  fmodel1:any={};
  cmodel:any={};
  objvhead:any={};
  arrcmbdet:any=[];
  msgexist="";
  corclasses:any=[];
  corsections:any=[];
  corsubjects:any=[];
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  arratscope:any=[{name:'Individual'},{name:'Combined'}];
  arropt:any=[{name:'Yes'},{name:'No'}];

  dropdownList = [];
  selectedItems = [];
  arrashead=[];
  arrastype=[];
  colums:any=[];
  columswp:any=[];
  gdcolums:any=[];
  
  arrcerftypes:any=[];
  arrformats:any=[];
  defctype:any;
  dropdownSettings:IDropdownSettings = {singleSelection: false,
    idField: 'stuid',
    textField: 'stunm',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 0,
    allowSearchFilter: true};
  constructor(private http: HttpClient,private fservice: FrontOffService,private cservice:ClassroomService, private mservice: MasterService,private modalService: NgbModal,private _global: AppGlobals) { }

  ngOnInit(): void {
    
    
    
    this.cmodel.oprtype='consolid';
    //this.onclickcorrection();
    this.masasshead();
    //this.masasstype();
    this.mascourse();
   
  }


  


getcertformat() {
  debugger
  var insid=localStorage.getItem('masclid')
  this.fservice.getcertformat(insid,5)
      .subscribe(
      resultArray => {
          console.log('bloodgp', resultArray);
          this.arrformats = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}

changeformat(p)
{
  this.fservice.getcertformatdet(p)
  .subscribe(
  resultArray => {
      console.log('bloodgp', resultArray);
      this.objformat = resultArray;
     
  },
  error => console.log("Error :: " + error)
  )
}

printcertificate(student,flnm){
  debugger
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');

  
   var url=this.fservice.callurl+flnm.filename+"?clcd="+clcd+"&aycd="+aycd+"&stuid="+student.stuid+"&clid="+student.clid+"&format="+flnm.frmid+"&crid="+student.crid+"&scid="+student.scid+"&astpid=1&asid="+this.fmodel.asid;

   window.open(url,'','_blank');
  
 }

 printcard(flnm){
  debugger
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');

  
   var url=this.fservice.callurl+flnm.filename+"?clcd="+clcd+"&aycd="+aycd+"&stuid=0&clid="+this.fmodel.clid+"&format="+flnm.frmid+"&crid="+this.fmodel.crid+"&scid="+this.fmodel.scid+"&astpid=1&asid="+this.fmodel.asid;

   window.open(url,'','_blank');
  
 }


  exportatsumsubrpt(opr)
  {
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     var url=this.cservice.callurl+"export/expmarksumsub.php?clcd="+clcd+"&aycd="+aycd+"&asid="+this.cmodel.asid+"&astpid="+this.cmodel.astpid+"&clid="+this.cmodel.clid+"&scid="+this.cmodel.scid+"&crid="+this.cmodel.crid+"&oprtype="+opr;
     console.log("url",url)
     window.open(url,'');
  
  }

  exportatsumgraderpt()
  {
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     var url=this.cservice.callurl+"export/expmarksumgrade.php?clcd="+clcd+"&aycd="+aycd+"&asid="+this.cmodel.asid+"&astpid="+this.cmodel.astpid+"&clid="+this.cmodel.clid+"&scid="+this.cmodel.scid+"&crid="+this.cmodel.crid;
     console.log("url",url)
     window.open(url,'');
  
  }
  attsubsum() {
    //this.cmodel.oprtype='sum_subwise';
    console.log('pstdat',this.cmodel);

    this.cservice.marksumsub(this.cmodel)
    .subscribe(resultArray => {
        console.log('ret-by-atd', resultArray);
        this.attdata = resultArray;
this.colums=Object.keys(resultArray[0]);
        //alert(resultArray.message);

    }, error =>
        alert('error in connection')
    );
  }


  attsubsumwp() {
    //this.cmodel.oprtype='sum_subwise';
    console.log('pstdat',this.cmodel);

    this.cservice.marksumsubwp(this.cmodel)
    .subscribe(resultArray => {
        console.log('ret-by-atd', resultArray);
        this.attdatawp = resultArray;
this.columswp=Object.keys(resultArray[0]);
        //alert(resultArray.message);

    }, error =>
        alert('error in connection')
    );
  }

  markssumgrade() {
    //this.cmodel.oprtype='sum_subwise';
    console.log('pstdat',this.cmodel);

    this.cservice.marksumgrade(this.cmodel)
    .subscribe(resultArray => {
        console.log('ret-by-atd', resultArray);
        this.arrmsumgd = resultArray;
this.gdcolums=Object.keys(resultArray[0]);
        //alert(resultArray.message);

    }, error =>
        alert('error in connection')
    );
  }

  corclass() {
    this.mservice.masclass()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
           // resultArray.unshift({clid:"0",clnm:"ALL",clcd:"ALL"});
            this.corclasses = resultArray;
            
            this.cmodel.clid=resultArray[0].clid;
            this.fmodel.clid=resultArray[0].clid;
            this.corsection();
           // this.masperiod();
           // this.mascourse();
           
        },
        error => console.log("Error :: " + error)
        )
  }

  onclasschange()
      {
        this.corsection();
this.getstudentsdata();
      }
  
      getstudentsdata() {
        this.cservice.getstudents_clwise(this.fmodel.clid,this.fmodel.scid,this.fmodel.crid)
            .subscribe(
            resultArray => {
                console.log('bloodgp', resultArray);
                this.arrstudent = resultArray;
            //   this.fmodel.stuid= resultArray[0].stuid;
              //  this.SelectReportDetails();
            },
            error => console.log("Error :: " + error)
            )
      }


  corsection() {
    this.mservice.massection()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            //resultArray.unshift({scid:"0",scnm:"ALL",sccd:"ALL"});
            this.corsections = resultArray;
            
            this.cmodel.scid=resultArray[0].scid;
            this.fmodel.scid=resultArray[0].scid;
            this.attsubsum();
            
        },
        error => console.log("Error :: " + error)
        )
  }

  mascourse() {
      this.mservice.mascourse()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
             // resultArray.unshift({crid:"0",crnm:"ALL",crcd:"ALL"});
              this.arrcourse = resultArray;
              this.fmodel.crid=resultArray[0].crid;
              this.fmodel1.crid=resultArray[0].crid;
              this.cmodel.crid=resultArray[0].crid;
            
              this.corclass();
          },
          error => console.log("Error :: " + error)
          )
    }

    masasshead() {
      this.mservice.sel_sp_masasshead()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.arrashead = resultArray;
              this.cmodel.asid=resultArray[0].asid;
              this.fmodel.asid=resultArray[0].asid;
             // this.fmodel.assid=resultArray[0].asid;
             this.masasstype();
          },
          error => console.log("Error :: " + error)
          )
    }
    masasstype() {
      this.mservice.sel_sp_masasstype()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.arrastype = resultArray;
              this.cmodel.astpid=resultArray[0].astpid;
             // this.fmodel.asstypeId=resultArray[0].astpid;
          },
          error => console.log("Error :: " + error)
          )
    }
}
